import type { FetchFn, Logger, InteractionsConfig } from '@wix/thunderbolt-becky-types'
import type { BuilderComponentsHierarchy } from '@wix/thunderbolt-commons'
import type { SpecMapBuilderComponent, ViewerClientSpecMap, BuilderComponentData } from '@wix/thunderbolt-symbols'

export const getBuilderTypeToInteractionsConfig = async (
	fetchFn: FetchFn,
	logger: Logger,
	clientSpecMap: ViewerClientSpecMap,
	allBuilderComponentsOnPage: Set<string>
): Promise<Record<BuilderComponentData['type'], InteractionsConfig>> => {
	const builderTypeToInteractionsConfig: Record<SpecMapBuilderComponent['type'], InteractionsConfig> = {}
	const fetchPromises: Array<Promise<void>> = []

	Object.values(clientSpecMap).forEach((appSpec) => {
		appSpec.components?.filter((comp) => comp.type === 'EDITOR_REACT_COMPONENT').forEach((comp) => {
			const interactionsUrl = comp.data.resources.interactions?.url
			if (interactionsUrl && allBuilderComponentsOnPage.has(comp.data.type)) {
				const fetchPromise = fetchFn(interactionsUrl)
					.then((response) => {
						if (!response.ok) {
							throw new Error(`http error, status: ${response.status}, text: ${response.statusText}`)
						}
						return response.json()
					})
					.then((interactionsConfig: InteractionsConfig) => {
						builderTypeToInteractionsConfig[comp.data.type] = interactionsConfig
					})
					.catch((e) => logger.error(e))
				fetchPromises.push(fetchPromise)
			}
		})
	})

	await Promise.all(fetchPromises)
	return builderTypeToInteractionsConfig
}
